import axios from "axios";
import { TrackEventRequest, platformApiApi } from "@capone/platform-api";
import { getGlobalTrackingProperties } from "@capone/common";
import { store } from "b2b-base/src/app/store";
import { config } from "../../config";

export const trackEvent = async (req: TrackEventRequest): Promise<boolean> => {
  try {
    req.properties = {
      ...req.properties,
      ...getGlobalTrackingProperties(
        config.TENANT,
        store.getState().rootReducer
      ),
    };

    const res = await platformApiApi(axios).apiV0TrackingEventPost(req, {
      baseURL: config.baseURL,
    });

    return res.data.Response === "Success";
  } catch (e) {
    console.error(e);
    throw e;
  }
};
